/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useState } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { useAuth } from "../../auth";
import Success from "./files/Success";
import ViewOrders from "./files/ViewOrders";
import OfflineOrders from "./files/offline";
import OrderHistory from "./files/History";
import OrderDetails from "./files/orderDetails";
const OrdersPage = () => {
  const { currentUser } = useAuth();
  const [data, setData] = useState<any>(null);

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="/list"
          element={
            <>
              <OfflineOrders />
            </>
          }
        />

        <Route
          path="/view"
          element={
            <>
              <ViewOrders />
            </>
          }
        />

        <Route
          path="/success"
          element={
            <>
              <Success />
            </>
          }
        />
          <Route
          path="/history"
       
          element={
            <>
              <OrderHistory/>
            </>
          }
        />
          <Route
          path="/order-details/:id"
          element={
            <>
              <OrderDetails/>
            </>
          }
        />
        <Route index element={<Navigate to="list" />} />
      </Route>
    </Routes>
  );
};

export default OrdersPage;
